import { render } from "./SlotModels.vue?vue&type=template&id=25bf6699&scoped=true"
import script from "./SlotModels.vue?vue&type=script&lang=js"
export * from "./SlotModels.vue?vue&type=script&lang=js"

import "./SlotModels.vue?vue&type=style&index=0&id=25bf6699&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25bf6699"]])

export default __exports__